<template>
  <b-modal
    ref="enable-drip-switch-modal"
    hide-header
    hide-footer
    class="text-center"
    centered
    :visible="isEnableDripSwitchOpen"
    @hidden="onCancel"
  >
    <div class="d-flex justify-content-end">
      <b-link class="drip-text-button mr-2 h3" @click="onCancel">
        <b-icon-x class="color-wealthy-green-50" scale="1.2" />
      </b-link>
    </div>
    <div v-if="invoiceLevel" class="modal-common">
      <p class="font-weight-bold modal-title">
        {{
          $t('dashboard.enableDripSwitchModal.title', {
            invoice_number: this.refId
          })
        }}
      </p>
      <p class="modal-body">
        {{ $t('dashboard.enableDripSwitchModal.description') }}
      </p>
      <b-row class="modal-buttons-container">
        <b-col>
          <action-button variant="solid" :click="toggleDripSwitchStatus">
            <b-icon-arrow-repeat
              v-if="isAPIFullFilled"
              animation="spin"
              class="mr-2 color-white"
            />
            {{ $t('dashboard.enableDripSwitchModal.confirm') }}
          </action-button>
        </b-col>
        <b-col>
          <action-button variant="outline" :click="onCancelHandler">
            {{ $t('dashboard.enableDripSwitchModal.cancel') }}
          </action-button>
        </b-col>
      </b-row>
    </div>
    <div v-else class="modal-common">
      <p class="font-weight-bold modal-title">
        {{ $t('dashboard.enableDripSwitchModal.optionHeading') }}
      </p>
      <div class="d-flex flex-column align-items-center">
        <div>
          <b-form-checkbox
            v-model="inrOptions"
            name="inrInvoice"
            value="all_invoices"
            class="checkbox-group"
          >
            {{ $t('dashboard.enableDripSwitchModal.enableAll') }}
          </b-form-checkbox>
          <b-form-checkbox
            v-model="inrOptions"
            name="inrInvoice"
            value="this_invoices"
            class="checkbox-group"
          >
            {{ $t('dashboard.enableDripSwitchModal.enableInvoice') }}
          </b-form-checkbox>
        </div>
      </div>
      <div v-if="showErrorMessage" class="error-message">
        {{ $t('dashboard.enableDripSwitchModal.selectAnOption') }}
      </div>
      <p class="modal-text">
        {{ $t('dashboard.enableDripSwitchModal.alternateDescription') }}
      </p>
      <b-row class="modal-buttons-container">
        <b-col>
          <action-button variant="solid" :click="toggleDripSwitchStatus">
            <b-icon-arrow-repeat
              v-if="isAPIFullFilled"
              animation="spin"
              class="mr-2 color-white"
            />
            {{ $t('dashboard.enableDripSwitchModal.confirm') }}
          </action-button>
        </b-col>
        <b-col>
          <action-button variant="outline" :click="onCancelHandler">
            {{ $t('dashboard.enableDripSwitchModal.cancel') }}
          </action-button>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>
<script>
import invoiceService from '@/services/invoice'
import ActionButton from '@/components/common/ActionButton'

export default {
  props: {
    isEnableDripSwitchOpen: {
      type: Boolean,
      default: true
    },
    refId: String,
    invoiceId: {
      type: Number,
      default: null
    },
    invoiceLevel: {
      type: Boolean,
      default: false
    },
    dataToSend: Object,
    onClose: Function,
    onCancel: Function,
    onSuccess: Function
  },
  data() {
    return {
      inrOptions: 'this_invoices',
      showErrorMessage: false,
      isAPIFullFilled: false
    }
  },
  methods: {
    toggleDripSwitchStatus() {
      this.isAPIFullFilled = true
      const screenLevel =
        this.$route.name === 'invoicesAdd' ? 'Invoice' : 'User'
      const screenLevelText = this.invoiceLevel ? 'Invoice' : 'User'
      this.$mpTrack(
        `Enable ${screenLevel} INR Confirmation`,
        this.$route.name === 'invoicesAdd'
          ? { invoiceId: this.dataToSend.invoice_id }
          : null
      )
      let dataToSend = this.dataToSend
      if (this.$route.name === 'invoicesAdd') {
        if (!this.inrOptions) {
          this.showErrorMessage = true
          this.isAPIFullFilled = false
          return
        }
        if (this.inrOptions === 'all_invoices') {
          dataToSend = {
            user_id: this.dataToSend.user_id,
            enabled: true
          }
        }
        if (this.inrOptions === 'this_invoices') {
          dataToSend = {
            user_id: this.dataToSend.user_id,
            invoice_id: this.invoiceId,
            enabled: true
          }
        }
      }
      this.$mpTrack(`Enable ${screenLevelText} INR Confirmation`)
      return invoiceService
        .updateRemittanceStatus(dataToSend)
        .then(({ status, data }) => {
          this.isAPIFullFilled = false
          if (status === 200) {
            this.onSuccess()
            if (this.$route.name === 'invoicesAdd') {
              if (this.invoiceLevel) {
                this.inrOptions = 'this_invoices'
              }
              this.$mpTrack(
                `${this.$route.name} - Enable DRIP Switch for ${
                  this.inrOptions === 'all_invoices' ? 'user' : 'invoice'
                } level`
              )
              this.onClose(
                this.inrOptions === 'all_invoices' ? 'user' : 'invoice'
              )
            } else {
              this.$mpTrack(
                `${this.$route.name} - Enable DRIP Switch for ${
                  !this.invoiceLevel ? 'user' : 'invoice'
                } level`
              )
              this.onCancel()
            }
          } else {
            this.$notify({
              title: this.$t('notifications.somethingWrong.title'),
              text: this.$t('notifications.somethingWrong.text'),
              type: 'error'
            })
          }
        })
        .catch(() => {
          this.isAPIFullFilled = false
          return this.$notify({
            title: this.$t('notifications.somethingWrong.title'),
            text: this.$t('notifications.somethingWrong.text'),
            type: 'error'
          })
        })
    },
    onCancelHandler() {
      const screenLevel =
        this.$route.name === 'invoicesAdd' ? 'Invoice' : 'User'
      this.$mpTrack(
        `Get my funds in INR 'Cancel' button clicked at ${screenLevel} level`,
        this.$route.name === 'invoicesAdd'
          ? { invoiceId: this.dataToSend.invoice_id }
          : null
      )
      this.onCancel()
    }
  },
  components: {
    ActionButton
  }
}
</script>
<style lang="scss" scoped>
.modal-common {
  margin-top: 8px;
  padding-left: 8px;
  padding-right: 8px;
  padding-bottom: 40px;
  .modal-title {
    font-size: 1.6rem !important;
    margin-bottom: 16px;
    line-height: 30px;
    text-align: center;
    color: $noble-blue-500;
  }
  .modal-text {
    text-align: center;
    font-size: 12px;
    color: $black;
  }
  .modal-body {
    text-align: center;
    font-size: 16px;
    margin: 0px;
    padding: 0px;
    color: $black;
  }
  .modal-buttons-container {
    margin-top: 40px;
    .modal-buttons {
      width: 100% !important;
      border-radius: 8px;
    }
  }
}
.checkbox-group {
  margin-bottom: 12px;
  color: $noble-blue-500;
  .custom-control-label::before {
    border: 2px solid $wealthy-green-500;
  }
}
.error-message {
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  color: $danger;
  text-align: center;
  margin-bottom: 8px;
}
</style>
